import React, { ReactNode } from 'react'

import { TextFieldProps } from '@mui/material/TextField'
import { ControllerProps } from 'react-hook-form'

export interface IAppRouteSetting {
  path?: string
  guard?: React.FunctionComponent<{ children: React.ReactNode }>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  layout?: React.FunctionComponent<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: React.FunctionComponent<any> | React.LazyExoticComponent<React.FunctionComponent<any>>
  routes?: Array<IAppRouteSetting>
  exact?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FormInputFieldEntity = TextFieldProps & {
  type?: string
  name: string
  label?: ReactNode
  id?: string
  placeholder?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateValue?: (name: string, value: any) => void
  cssProp?: string
  disabled?: boolean
  shouldValidateParam?: boolean
  fieldIsDirty?: boolean
}

export type ControlledTextFieldProps = TextFieldProps & ControllerProps

export type ServerResponse<T> = {
  data: T
  success: boolean
  message?: string
  time: string
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
}

export enum SortDirectionCapital {
  asc = 'ASC',
  desc = 'DESC',
}

export enum Direction {
  top = 'top',
  right = 'right',
  bottom = 'bottom',
  left = 'left',
}

export interface PagePagination<T, F = []> {
  perPage: number
  page: number
  columns: (keyof T)[]
  itemCount: number
  pageCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  period: string[] | null[]
  account: number
  order: SortDirectionCapital
  orderBy: keyof T | null
  fromCalendar: boolean
  search: string
  filters: F
}

export interface PagePaginationFromKeys<T, F = []> {
  perPage: number
  page: number
  columns: T[]
  itemCount: number
  pageCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  period: string[] | null[]
  account: number
  order: SortDirectionCapital
  orderBy: T | null
  fromCalendar: boolean
  search: string
  filters: F
}

export type CountryOption = {
  label: string
  code: string
}

export enum Currencies {}
